import { z } from "zod"

import { choiceSchema } from "./choice"
import { propertyKeySchema } from "./property-key"

export const applicabilitySchema = z.object({
  /** The name of variable that this applicability
   * applies to. Examples include systemOwnership,
   * azimuth, and tilt. */
  applicabilityKey: z.string(),
  /** A user-presentable name for this applicability. */
  displayName: z.string(),
  /** A user-presentable description of what this
   * applicability represents. */
  description: z.string(),
  /** If there is a single value that is allowed for
   * this applicability, it will show up here.
   * For example, if systemOwnership requires host,
   * it will be here. */
  requiredValue: z.string().nullable().optional(),
  /** For numeric applicabilities, the minimum allowed value. */
  minValue: z.number().nullable().optional(),
  /** For numeric applicabilities, the maximum allowed value. */
  maxValue: z.number().nullable().optional(),
  /** For formulaic applicabilities, the relationship that
   * must be true for this applicability relative to
   * its quantityKey. For example, estimatedFirstYearkWh
   * might have a quantityKey of 110percentAnnualConsumption
   * and an operator of <. This indicates that the estimated
   * first year production of the solar power system must
   * be less than 110% of the customer’s annual consumption. */
  operator: z.string().nullable().optional(),
  /** For formulaic applicabilities, a pointer to a PropertyKey
   * that holds the formula defining this applicability. */
  quantityKey: propertyKeySchema.optional().nullable().or(z.string().optional()),
  /** For applicabilities with a fixed set of choices,
   * the list of available choices. */
  choices: z.array(choiceSchema).nullable().optional(),
})

export type Applicability = z.infer<typeof applicabilitySchema>
